import { Link, useParams } from 'react-router-dom';
import { getComicBySlug, getComicsByCategory } from '@/mocks/comics';

export default function RelatedComics() {
  const { slug } = useParams<{ slug: string }>();
  const comic = slug ? getComicBySlug(slug) : undefined;
  const relatedComics = comic
    ? getComicsByCategory(comic.categorySlug)
        .filter((c) => c.slug !== slug)
        .slice(0, 4)
    : [];

  if (relatedComics.length === 0) return null;

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <span className="text-xs font-medium text-foreground-500 tracking-widest">
            相关推荐
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mt-3">
            猜你喜欢
          </h2>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-product-shop="">
          {relatedComics.map((c) => (
            <Link
              key={c.id}
              to={`/comic/${c.slug}`}
              className="group cursor-pointer"
            >
              <div className="relative rounded-2xl overflow-hidden aspect-[3/4] mb-3 bg-background-200">
                <img
                  src={c.coverImage}
                  alt={c.title}
                  title={`${c.title}高清漫画全集免费阅读下拉式 - 178漫画网`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-0 left-0 right-0 p-3 bg-gradient-to-t from-black/60 to-transparent">
                  <span className="text-white/80 text-[10px]">
                    ⭐ {c.rating}
                  </span>
                </div>
              </div>
              <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {c.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">
                {c.author} · {c.category}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}